import { RealmSelectorContainer } from './RealmSelectorContainer';
import { AppTheme } from './theme';

export const App: React.FC = () => {
    return (
        <AppTheme stylesInject={true} themeMode="light">
            <RealmSelectorContainer />
        </AppTheme>
    );
};

export default App;
